"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIVIDER_LENGTHS = void 0;
var DIVIDER_LENGTHS = Object.freeze({
  auto: 'auto',
  fixed: 'fixed',
  fluid: 'fluid'
});
exports.DIVIDER_LENGTHS = DIVIDER_LENGTHS;